exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mall-image {\n  height: 250px;\n  width: 250px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall/mall-profile/mall-profile.component.scss
// module id = ../../../../../src/app/mall/mall-profile/mall-profile.component.scss
// module chunks = main